class RenderWaterPass extends THREE.Pass {
    constructor(scene, camera) {
        super();
        this.scene = scene;
        this.camera = camera;
        this.needsSwap = false;
    }

    render(renderer, writeBuffer, readBuffer, delta, maskActive) {
        this.scene.traverse(obj => {
            if (obj.isWater && obj.visible)
                obj.renderWater(renderer, this.scene, this.camera);
        });
    }
}

export default RenderWaterPass;
export { RenderWaterPass };